
import React from 'react';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';

interface ParticipantAvatarProps {
  name: string;
  avatarUrl: string;
}

const ParticipantAvatar: React.FC<ParticipantAvatarProps> = ({ name, avatarUrl }) => {
  const initials = name
    .split(' ')
    .map(n => n[0])
    .join('');

  return (
    <Avatar className="h-24 w-24">
      <AvatarImage src={avatarUrl} />
      <AvatarFallback>{initials}</AvatarFallback>
    </Avatar>
  );
};

export default ParticipantAvatar;
